export default "__VITE_ASSET__SRUXcbJS__"